import React from "react";
import {
  FaLinkedin,
  FaFacebook,
  FaTiktok,
  FaInstagram,
  FaTwitter,
  FaWhatsapp
} from "react-icons/fa";
import "../styles/Footer.css";

const Footer = () => {
  const shareUrl = encodeURIComponent("https://thelevelplay.com");
  const message = encodeURIComponent("Enjoy free 2 player games with friends!");

  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">
          © {new Date().getFullYear()} LevelPlay. All rights reserved.
        </p>

        {/* Social Media Share Icons */}
        <div className="social-icons">
          <a
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin className="icon" />
          </a>
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}&quote=${message}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebook className="icon" />
          </a>
          <a
            href={`https://twitter.com/intent/tweet?url=${shareUrl}&text=${message}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTwitter className="icon" />
          </a>
          <a
            href={`https://wa.me/?text=${message}%20${shareUrl}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp className="icon" />
          </a>
          
          <a
            href="https://www.tiktok.com/@yourusername"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTiktok className="icon" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
